var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"underline text-indigo-600 hover:text-indigo-800",attrs:{"href":_vm.$vnode.data.href}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }